var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"list-btn-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.icon}),_c('u-tooltip',{attrs:{"offset":[5,5]}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }